import React, { useState } from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { Link } from "react-router-dom";

const CreateNewPassword = () => {
	return (
		<>
			<div className="main-banner-heading1">
				<Header />
			</div>
			<section className="signin">
				<div className="container">
					<div className="row">
						<div className="col-lg-6 mx-auto">
							<div className="main-bg-signin">
								<h2 className="main-heading level-2 text-center mt-3 mb-3 main-heading-font dark-color wow animate__animated animate__zoomIn">
									Create New Password{" "}
								</h2>
								<div className="row">
									<div className="col-lg-12 mb-2">
										<div class="form-group">
											<input
												type="password"
												className="form-control"
												id="firstName"
												placeholder="Create New Password"
											/>
										</div>
									</div>
									<div className="col-lg-12 mb-2">
										<div class="form-group">
											<input
												type="text"
												className="form-control"
												id="firstName"
												placeholder="Confirm Password"
											/>
										</div>
									</div>
								</div>
								<div className="row">
									<div className="col-lg-12">
										<Link
											class="btn wrapper-btn-main w-100 log-in mt-2 level-7 primary-regular-font text-decoration-none"
											href="/user-signup-detail"
											to="/otp"
										>
											<span class="bg-wrapper w-100">Submit</span>
										</Link>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<Footer />
		</>
	);
};

export default CreateNewPassword;
